// import { useEffect } from "react";
// import L from "leaflet";
// import "leaflet-routing-machine";
// import { useMap } from "react-leaflet";

// const carIcon = new L.Icon({
//   iconUrl: "/assets/img/car_repair_black_24dp 2.png", // Ensure this is in `public/assets/`
//   iconSize: [30, 30],
// });

// const chargingIcon = new L.Icon({
//   iconUrl: "/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg", // Ensure this is in `public/assets/`
//   iconSize: [30, 30],
// });

// const RoutingMachine = ({ carLocation, chargingStation }) => {
//   const map = useMap();
//   const mapboxAccessToken = "pk.eyJ1Ijoic205MjU0MTMtdHRsIiwiYSI6ImNtN2J1c3kzdDBnYzYybHNjZ3M2dG1iZXAifQ.amtfOJA0OjwtBroQhPk5BA"; // Replace with your token

//   useEffect(() => {
//     if (!map) return;

//     const routingControl = L.Routing.control({
//       waypoints: [
//         L.latLng(carLocation[0], carLocation[1]), // Start point (Car)
//         L.latLng(chargingStation[0], chargingStation[1]), // End point (Charging Station)
//       ],
//       routeWhileDragging: true,
//       lineOptions: {
//         styles: [{ color: "#358696", weight: 10 }],
//       },
//       show: false,
//       addWaypoints: false,
//       // ✅ Disable default markers
//       createMarker: function (i, waypoint, n) {
//         if (i === 0) {
//           // Start marker (Car)
//           return L.marker(waypoint.latLng, { icon: carIcon }).bindPopup("Vehicle Location");
//         } else if (i === n - 1) {
//           // End marker (Charging Station)
//           return L.marker(waypoint.latLng, { icon: chargingIcon }).bindPopup("Nearest Charging Station");
//         }
//         return null;
//       },
//       router: L.Routing.mapbox(mapboxAccessToken), // Use Mapbox API
//     }).addTo(map);

//     return () => map.removeControl(routingControl); // Cleanup on unmount
//   }, [map, carLocation, chargingStation]);

//   return null;
// };

// export default RoutingMachine;


// import L from "leaflet";
// import "leaflet-routing-machine";
// import { useEffect, useRef, useState } from "react";
// import { useMap } from "react-leaflet";

// const carIcon = new L.Icon({
//   iconUrl: "/assets/img/car_repair_black_24dp 2.png", // Ensure this is in `public/assets/`
//   iconSize: [30, 30],
// });

// const chargingIcon = new L.Icon({
//   iconUrl: "/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg", // Ensure this is in `public/assets/`
//   iconSize: [30, 30],
// });

// const RoutingMachine = ({ carLocation, chargingStation }) => {
//   const map = useMap();
//   const routingControlRef = useRef(null);

//   useEffect(() => {
//     if (!carLocation || !chargingStation) return;

//     // ✅ Ensure routing control is properly removed before adding a new one
//     if (routingControlRef.current) {
//       try {
//         map.removeControl(routingControlRef.current);
//       } catch (error) {
//         console.warn("Routing control already removed:", error);
//       }
//       routingControlRef.current = null;
//     }

//     // ✅ Check for valid coordinates
//     if (
//       !Array.isArray(carLocation) ||
//       carLocation.length !== 2 ||
//       isNaN(carLocation[0]) ||
//       isNaN(carLocation[1]) ||
//       !Array.isArray(chargingStation) ||
//       chargingStation.length !== 2 ||
//       isNaN(chargingStation[0]) ||
//       isNaN(chargingStation[1])
//     ) {
//       console.error("Invalid carLocation or chargingStation coordinates.");
//       return;
//     }

//     // ✅ Routing control setup
//     const routingControl = L.Routing.control({
//       waypoints: [
//         L.latLng(carLocation[0], carLocation[1]),
//         L.latLng(chargingStation[0], chargingStation[1]),
//       ],
//       createMarker: (i, waypoint, n) => {
//         if (i === 0) return L.marker(waypoint.latLng, { icon: carIcon }).bindPopup("Vehicle Location");
//         if (i === n - 1) return L.marker(waypoint.latLng, { icon: chargingIcon }).bindPopup("Nearest Charging Station");
//         return null;
//       },
//       routeWhileDragging: false, // 🔹 Prevents rerouting on dragging
//       show: false, // 🔹 Hides route info (KM, Min, Address)
//       addWaypoints: false,
//       lineOptions: { styles: [{ color: "#358696", weight: 6 }] },
//       fitSelectedRoutes: false,
//       router: L.Routing.osrmv1({ serviceUrl: "https://router.project-osrm.org/route/v1" }),
//     });

//     // ✅ Hide route info panel
//     routingControl.on("routesfound", (e) => {
//       const container = document.querySelector(".leaflet-routing-container");
//       if (container) container.style.display = "none";

//       // ✅ Ensure map zooms correctly (fixed at 100%)
//       setTimeout(() => {
//         try {
//           if (map && e.routes.length > 0) {
//             map.fitBounds(e.routes[0].bounds, { padding: [50, 50], maxZoom: 18 });
//           }
//         } catch (err) {
//           console.error("Error adjusting map bounds:", err);
//         }
//       }, 500);
//     });

//     routingControlRef.current = routingControl;
//     map.addControl(routingControl);

//     return () => {
//       if (routingControlRef.current) {
//         try {
//           map.removeControl(routingControlRef.current);
//         } catch (error) {
//           console.warn("Error removing routing control:", error);
//         }
//         routingControlRef.current = null;
//       }
//     };
//   }, [map, carLocation, chargingStation]);

//   return null;
// };

// export default RoutingMachine;

import L from "leaflet";
import "leaflet-routing-machine";
import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

const carIcon = new L.Icon({
  iconUrl: "/assets/img/car_repair_black_24dp 2.png", // Ensure this is in `public/assets/`
  iconSize: [30, 30],
});

const chargingIcon = new L.Icon({
  iconUrl: "/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg", // Ensure this is in `public/assets/`
  iconSize: [30, 30],
});

const RoutingMachine = ({ carLocation, chargingStation }) => {
  const map = useMap();
  const routingControlRef = useRef(null);

  useEffect(() => {
    if (!carLocation || !chargingStation) return;

    // ✅ Ensure routing control is properly removed before adding a new one
    if (routingControlRef.current) {
      try {
        map.removeControl(routingControlRef.current);
      } catch (error) {
        console.warn("Routing control already removed:", error);
      }
      routingControlRef.current = null;
    }

    // ✅ Check for valid coordinates
    if (
      !Array.isArray(carLocation) ||
      carLocation.length !== 2 ||
      isNaN(carLocation[0]) ||
      isNaN(carLocation[1]) ||
      !Array.isArray(chargingStation) ||
      chargingStation.length !== 2 ||
      isNaN(chargingStation[0]) ||
      isNaN(chargingStation[1])
    ) {
      console.error("Invalid carLocation or chargingStation coordinates.");
      return;
    }

    // ✅ Routing control setup
    const routingControl = L.Routing.control({
      waypoints: [
        L.latLng(carLocation[0], carLocation[1]),
        L.latLng(chargingStation[0], chargingStation[1]),
      ],
      createMarker: (i, waypoint, n) => {
        if (i === 0) return L.marker(waypoint.latLng, { icon: carIcon }).bindPopup("Vehicle Location");
        if (i === n - 1) return L.marker(waypoint.latLng, { icon: chargingIcon }).bindPopup("Nearest Charging Station");
        return null;
      },
      routeWhileDragging: false, // 🔹 Prevents rerouting on dragging
      show: false, // 🔹 Hides route info (KM, Min, Address)
      addWaypoints: false,
      lineOptions: { styles: [{ color: "#358696", weight: 6 }] },
      fitSelectedRoutes: false,
      router: L.Routing.osrmv1({ serviceUrl: "https://router.project-osrm.org/route/v1" }),
    });

    // ✅ Hide route info panel
    routingControl.on("routesfound", (e) => {
      const container = document.querySelector(".leaflet-routing-container");
      if (container) container.style.display = "none";

      // ✅ Ensure map zooms correctly (fixed at 100%)
      setTimeout(() => {
        try {
          if (map && e.routes.length > 0) {
            map.fitBounds(e.routes[0]?.bounds, { padding: [50, 50], maxZoom: 18 });
          }
        } catch (err) {
          console.error("Error adjusting map bounds:", err);
        }
      }, 5000);
    });

    routingControlRef.current = routingControl;
    map.addControl(routingControl);

    return () => {
      if (routingControlRef.current) {
        try {
          map.removeControl(routingControlRef.current);
        } catch (error) {
          console.warn("Error removing routing control:", error);
        }
        routingControlRef.current = null;
      }
    };
  }, [map, carLocation, chargingStation]);

  return null;
};

export default RoutingMachine;
